import get from 'lodash.get';

import { selectUserLogin } from '../../../../redux/auth/login/selectors';
import { createDeepEqualSelector } from '../../../../redux/utils/selectors';

export const selectIsLoading = createDeepEqualSelector(selectUserLogin, (login) => get(login, 'loading', false));

export const selectError = createDeepEqualSelector(selectUserLogin, (login) => get(login, 'err', false));

export const selectErrorMessage = createDeepEqualSelector(selectUserLogin, (login) => get(login, 'errMsg', 'Error'));
